var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowSortUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.39961 11.3508L2.39961 1L3.59961 1L3.59961 11.3508L2.39961 11.3508Z",
    fill: "#474F60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60742 3L3.0014 0.870605L0.39537 3",
    stroke: "#474F60",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowSortUp);
export default __webpack_public_path__ + "static/media/icon_arrow_sort_up.4a82c7ee07ef75e69c9cb20cf205f1a5.svg";
export { ForwardRef as ReactComponent };